<template>
  <!-- <groupCustomerCn v-if="!funcView.partner_customer_simple"></groupCustomerCn>
  <groupCustomerUs v-else></groupCustomerUs> -->
  <component :is="name"></component>
</template>

<script>
import groupCustomerCn from './children/groupCustomer.vue';
import groupCustomerUs from './children/groupCustomer_us.vue';

export default {
  name: 'groupCustomer',
  components: { groupCustomerCn, groupCustomerUs },
  data() {
    return {
      name: ''
    };
  },
  mounted() {
    // ocr识别 简版权限全在总部上管理
    this.getFuncView(null, () => {
      if (this.funcView.partner_customer_simple) {
        this.name = 'groupCustomerUs';
      } else {
        this.name = 'groupCustomerCn';
      }
    });
  }
};
</script>
